import { createContext, useCallback, useContext, useState } from "react";
import { toast } from "react-toastify";
import { apiRequest } from "src/async/apiUtils";
import { isEqual } from "src/hooks/useHasChanges";

export const SiteContext = createContext();

export const SiteSettingsProvider = ({ children }) => {
  const [siteLoading, setSiteLoading] = useState(true);
  const [site, setSite] = useState({});

  const loadSiteSettings = useCallback(async () => {
    setSiteLoading(true);
    try {
      const url = "portal/site-settings/details";
      const { data: resData } = await apiRequest("GET", `/${url}`);

      const newSettings = resData.data;

      setSite((prevSite) => {
        if (!isEqual(prevSite, newSettings)) {
          return newSettings;
        }
        return prevSite;
      });

      return newSettings;
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSiteLoading(false);
    }
  }, []);

  return (
    <SiteContext.Provider
      value={{
        loading: siteLoading,
        site,
        setSite,
        reloadSettings: loadSiteSettings,
      }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteContext);
